module.exports = __webpack_public_path__ + "img/home-7-luban.56e7fa1b.png";